import * as CryptoJS from 'crypto-js';
export function parseText(encrypted: string): any {
  return CryptoJS.enc.Hex.parse(encrypted.slice(96));
}
